import $ from 'jquery'
import { Turbo } from '@hotwired/turbo-rails'
import client from '../../../lib/axiosClient'
import { buyersDealMessagesPath } from '../../../lib/rails-routes'
import { showError, showSuccessWithTurbo } from 'src/lib/toastify-js'

const dealId = (): number => {
  return Number(window.location.href.match(/deals\/([0-9]+)/)[1])
}

const ndaMessageTemplate = (): string => {
  return $('.js-buyer-nda-request-template').data('body')
}

const questionTemplate = (): string => {
  return $('.js-buyer-question-template').data('body')
}

const onReplyTemplateSelectButton = (event: Event): void => {
  event.preventDefault()
  const template = $('.js-buyers-reply-template:checked').val()
  if (template === 'nda_request') {
    $('.js-buyers-reply-template-select-button').prop('disabled', true)
    client
      .post(buyersDealMessagesPath({ dealId: dealId() }), {
        batch: 1,
        message: {
          buyer_template: 'nda_request',
          body: ndaMessageTemplate(),
        },
      })
      .then(() => {
        showSuccessWithTurbo('送信しました')
        Turbo.visit($('.js-buyers-reply-template-select-button').data('nextUrl'))
      })
      .catch((e) => {
        showError(e.response.data.errors.join(', '))
      })
    return
  }

  $('.js-message-body').val(questionTemplate)
  $('#js-reply-toolbar').fadeOut()
  $('#js-buyers-select-reply-template-modal').modal('hide')
  $('.js-new-message').removeClass('hidden')
  $('html,body').animate({ scrollTop: $('.js-new-message').offset().top })
}

const onTurboLoad = () => {
  const params = new URLSearchParams(window.location.search)
  if (params.get('show-reply-form') === '1') {
    $('#js-buyers-select-reply-template-modal').modal('show')
  }
}

$(document).on('turbo:load', onTurboLoad)
$(document).on('click', '.js-buyers-reply-template-select-button', onReplyTemplateSelectButton)
